export const models = {
  advertiser: {
    id: 'id',
    name: '名前',
    agencyId: '代理店id',
    agencyName: '代理店名',
    anAdvertiserId: 'AppNexusId',
    code: 'コード',
    email: 'メールアドレス',
    staffName: 'スタッフ名',
    status: 'ステータス',
    tel: '電話番号',
  },
}
